module.exports = __webpack_public_path__ + "11bdf59755c9d925539df2ffc75eb182.svg";